export type Tier = {
  name: string;
  id: string;
  href: string;
  priceMonthly: string;
  priceYearly: string;
  description: string;
  features: string[];
  featured: boolean;
  cta: string;
  onClick: () => void;
};
export const tiers: Tier[] = [{
  name: "Hobby",
  id: "tier-hobby",
  href: "#",
  priceMonthly: "$12/mo",
  priceYearly: "$108/yr",
  description: "Perfect for solopreneurs starting their first project.",
  features: ["3 active projects", "Unlimited brand names/project", "50 logo designs/month", "25,000 AI content credits/month", "1 customer persona/project (10 pain points)", "1 Viral Giveaway Campaign/project", "Launch copy for Product Hunt, Twitter, LinkedIn, Facebook, & Reddit"],
  featured: false,
  cta: "Start Now",
  onClick: () => {}
}, {
  name: "Pro",
  id: "tier-pro",
  href: "#",
  priceMonthly: "$29/mo",
  priceYearly: "$252/yr",
  description: "Perfect for founders managing multiple launches.",
  features: ["10 active projects", "Unlimited brand names/project", "250 logo designs/month", "100,000 AI content credits/month", "3 customer personas/project (30 pain points each)", "5 Viral Giveaway Campaigns/project", "Advanced analytics for campaigns", "Custom brand voice generator", "Launch copy for Product Hunt, Twitter, LinkedIn, Facebook, Reddit, & Microsites"],
  featured: true,
  cta: "Go Pro",
  onClick: () => {}
}, {
  name: "Ultimate",
  id: "tier-ultimate",
  href: "#",
  priceMonthly: "$99/mo",
  priceYearly: "$890/yr",
  description: "For power users, teams and future millionaires.",
  features: ["Unlimited active projects", "Unlimited brand names/project", "Unlimited logo designs", "500,000 AI content credits/month", "Unlimited customer personas/project (30+ pain points each)", "Unlimited Viral Giveaway Campaigns/project", "Priority analytics for campaigns", "Custom brand voice generator", "Customizable AI prompts for tailored content generation", "Team collaboration (3 team members)", "Launch copy for all platforms (Product Hunt, Twitter, LinkedIn, Facebook, Reddit, Microsites, & Custom Platforms)"],
  featured: false,
  cta: "Claim Ultimate",
  onClick: () => {}
}];